import { RichTextNode } from '@cinemark/content-api-client';
import type { SerializedTextNode } from '@payloadcms/richtext-lexical';
import { JSXConverter } from '@payloadcms/richtext-lexical/react';
import React from 'react';

type TextConverterFunction = (args: { node: SerializedTextNode; }) => React.ReactNode;

type RichTextTextConverterComponentProps = {
  defaultTextConverter: JSXConverter<SerializedTextNode>;
  node: SerializedTextNode;
};

export const RichTextTextConverterComponent = ({ defaultTextConverter, node }: RichTextTextConverterComponentProps): React.JSX.Element | null | undefined => {
  if (!node || node.type !== 'text') return null;

  const getColor = (color: string | undefined): string | null => {
    switch (color) {
      case 'cnk-primary': return 'text-primary';
      case 'cnk-primary-lighter': return 'text-lg';
      case 'cnk-primary-darker': return 'text-icon';
      default: return null;
    }
  };

  const overWrittenConverter = defaultTextConverter as TextConverterFunction;
  const defaultElement = overWrittenConverter({ node });
  const state = (node as unknown as RichTextNode).state;
  const colorClass = getColor(state?.color);

  if (!defaultElement) return null;
  if (!colorClass) return <>{defaultElement}</>;

  if (React.isValidElement(defaultElement)) {
    const elementWithClassName = defaultElement as React.ReactElement<{ className?: string; }>;

    return React.cloneElement(elementWithClassName, {
      className: `${elementWithClassName.props.className || ''} ${colorClass}`.trim(),
    } as Partial<{ className?: string; }>);
  }

  return <span className={colorClass}>{node.text}</span>;
};
